import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import iziToast from "izitoast";
import axios from "axios";
import Footer from "./Footer";

export const SuperLogin = () => {
    const { apipath, login, logout } = useAuth();
    const navigate = useNavigate();
    localStorage.removeItem('userData');
    const token = localStorage.getItem('token');
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    useEffect(() => {
        if (token != null) {
            logout();
        }
    });

    const [userData, setUserData] = useState({
        email: '',
        password: '',
    });

    const handleChange = (e) => {
        setUserData({ ...userData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        await axios.post(apipath + '/login', userData)
            .then((response) => {
                var data = response.data;
                
                console.log(data);
                if (data.status === "false") {
                    iziToast.error({
                        message: data.message,
                        position: "topCenter"
                    });
                    setIsLoading(false);
                }
                else {
                    if(data.user?.user_type === 'super_admin'){
                        localStorage.setItem('token', data.token);
                        localStorage.setItem('userType', data.user?.user_type);
                        localStorage.setItem('userData', JSON.stringify(data.user));
                        iziToast.success({
                            message: data.message,
                            position: "topCenter"
                        });
                        login(data.token, data.user?.user_type, JSON.stringify(data.user));
                        navigate('/dashboard');
                    }
                    else{
                        setIsLoading(false);
                        iziToast.error({
                            message: "Invalid Credentials",
                            position: "topCenter"
                        });
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error);
                iziToast.error({
                    message: error,
                    position: "topCenter"
                });
            });
    };
    return (
        <> 
        <span className={(isLoading) ? "flex items-center text-white bg-gray-400/75 justify-center absolute top-0 left-0 w-full h-full z-50" : "hidden"}>
            <svg
              className="w-5 h-5 mr-2 animate-spin"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4l3-3-3-3V4a10 10 0 1010 10h-4l3 3 3-3h-4a8 8 0 01-8 8z"
              ></path>
            </svg>
            Logging in...
          </span>
          
            {<Navbar page={"login"} />}
            <div className="min-h-screen flex items-center justify-center bg-teal-600">
                <div className="w-full max-w-md bg-white p-8 shadow-lg rounded-lg">
                    <h2 className="text-2xl font-bold text-center text-teal-800 mb-6">Super Admin Login</h2>
                    <form className="space-y-4" onSubmit={handleSubmit}>
                        <div>
                            {/* <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                Email address
                            </label> */}
                            <input
                                type="text"
                                id="email"
                                name="email"
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                placeholder="Enter your email or roll number"
                                required
                            />
                        </div>

                        <div className="relative">
                            {/* <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                Password
                            </label> */}
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                name="password"
                                onChange={handleChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                placeholder="Enter your password"
                                required
                            />
                            <button
                                type="button"
                                onClick={togglePasswordVisibility}
                                className="absolute inset-y-0 right-0 px-4 text-gray-600"
                            >
                                {showPassword ? <><i className="fa fa-eye-slash" title="hide"></i></> : <><i className="fa fa-eye" title="show"></i></>}
                            </button>
                        </div>

                        <div className="flex items-center justify-between pb-2">
                            {/* <label className="flex items-center">
                                <input
                                    type="checkbox"
                                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                                />
                                <span className="ml-2 text-sm text-gray-600">Remember me</span>
                            </label> */}
                            {/* <a href="#" className="text-sm text-indigo-600 hover:underline">
                                Forgot your password?
                            </a> */}
                        </div>

                        <button type="submit" className="w-full bg-teal-600 text-white py-2 rounded-md hover:bg-teal-700 transition duration-200">
                            Login
                        </button>
                    </form>

                    {/* <p className="mt-6 text-center text-sm text-gray-600">
                        Don't have an account?{' '}
                        <a href="#" className="text-indigo-600 hover:underline">
                            Sign up
                        </a>
                    </p> */}
                </div>
            </div>
            <Footer/>
        </>
    )
};